export const bankNameUrl = 'v1/credit/billing/payments/methods/bank';
export const paymentsUrl = 'v1/credit/billing/payments';
export const autopayUrl = 'v1/credit/billing/payments/autopay';
